import { render, staticRenderFns } from "./tasks.vue?vue&type=template&id=15a04a34&scoped=true&"
import script from "./tasks.vue?vue&type=script&lang=js&"
export * from "./tasks.vue?vue&type=script&lang=js&"
import style0 from "./tasks.vue?vue&type=style&index=0&id=15a04a34&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a04a34",
  null
  
)

export default component.exports